export const Urls = {
    GetActivities: "sharedActivity/GetActivities",
    AddActivity: "sharedActivity/AddActivity",
    DeleteActivity: "sharedActivity/DeleteActivity"
};
